"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var iconFactory_1 = require("../../utils/iconFactory");
// AEM-Name: LoaderIcon
exports.LoaderIcon = iconFactory_1.iconFactory({
    componentName: 'LoaderIcon',
    viewBox: '0 0 66 66',
    title: 'LoaderIcon',
    g: "<circle fill=\"none\" stroke-width=\"2\" stroke-linecap=\"round\" cx=\"33\" cy=\"33\" r=\"30\"/>",
    gThemed: { "ergo-one": { "viewBox": "0 0 66 66", "g": "<circle fill=\"none\" stroke-width=\"2\" stroke-linecap=\"round\" cx=\"33\" cy=\"33\" r=\"30\"/>" } }
});
exports.default = exports.LoaderIcon;
//# sourceMappingURL=LoaderIcon.js.map